<template>
  <el-table
    v-if="!loading && updatePoints && tabData.length > 0"
    height="100%"
    :data="tabData"
    style="width: 100%"
  >
    <el-table-column prop="name" label="名称" width="220"> </el-table-column>
    <el-table-column prop="period" label="本期总能耗">
      <template slot-scope="scope"> 
        <template v-if="node=='water'">
          <template v-if="scope.row.id!=30">
            --
          </template>
          <template v-else>
            {{ scope.row.period }}tce 
          </template>
        </template>
        <template v-else>
          {{ scope.row.period }}tce 
        </template>
      </template>
    </el-table-column>
    <el-table-column prop="previous" label="上期总能耗">
      <template slot-scope="scope"> 
        <template v-if="node=='water'">
          <template v-if="scope.row.id!=30">
            --
          </template>
          <template v-else>
            {{ scope.row.previous }}tce 
          </template>
        </template>
        <template v-else>
          {{ scope.row.previous }}tce 
        </template>
      </template>
    </el-table-column>
    <el-table-column prop="ringlv" label="环比率">
      <template slot-scope="scope">
        <template v-if="node=='water'">
          <template v-if="scope.row.id!=30">
            --
          </template>
          <template v-else>
            {{ scope.row.ringlv }}% 
          </template>
        </template>
        <template v-else>
          {{ scope.row.ringlv }}% 
        </template>
      </template>
    </el-table-column>
    <el-table-column prop="same" label="同期总能耗">
      <template slot-scope="scope"> 
        <template v-if="node=='water'">
          <template v-if="scope.row.id!=30">
            --
          </template>
          <template v-else>
            {{ scope.row.same }}tce 
          </template>
        </template>
        <template v-else>
          {{ scope.row.same }}tce 
        </template>
      </template>
    </el-table-column>
    <el-table-column prop="ratiolv" label="同比率">
      <template slot-scope="scope"> 
        <template v-if="node=='water'">
          <template v-if="scope.row.id!=30">
            --
          </template>
          <template v-else>
            {{ scope.row.ratiolv }}% 
          </template>
        </template>
        <template v-else>
          {{ scope.row.ratiolv }}% 
        </template>
      </template>
    </el-table-column>
  </el-table>
  <div v-else class="row-center tip">
    <img v-if="loading" src="../../../assets/img/loading.png" class="loading" />
    <img v-else src="../../../assets/img/not_found_data.png" alt="" />
  </div>
</template>

<script>
import {
  dateFormat,
} from "../../../util/DateUtil";
import { CompareClassifiedPower } from "../../../api/power";
import exportExcel from "../../../util/excel";
import Axios from "axios";
import { floatFormat } from "../../../util/MathUtil";

export default {
  name: "PowerTime",
  props: {
    loops: Array,
    range: String,
    date: Date,
    node: String,
  },
  data() {
    return {
      titles: [],
      loading: false,
      show: false,
      allPoints: [],
      currentCancelTokenSource: null,
    };
  },
  watch: {
    diagramStatus(n) {
      if (
        this.$route.params.name === "Extremum" &&
        this.$route.params.tag === "PowerTime"
      ) {
        if (n.type === "excel" && this.tabData.length > 0) {
          let data = [["名称", "本期总能耗","上期总能耗","环比率","同期总能耗",'同比率']];
          this.tabData.forEach((d) => {
            data.push([d.name, d.period+"tce", d.previous+"tce", d.ringlv+"%", d.same+"tce", d.ratiolv+"%"]);
          });
          exportExcel(data, "能耗同环比报表", []);
        } else {
          this.$message.warning("无图表数据！");
        }
      }
    },
    updatePoints(n) {
      this.currentCancelTokenSource.cancel("请求取消");
      this.reShow();
      this.getPoints(
        this.loops,
        ["ALTERNATE", "SEPARATED"],
        Axios.CancelToken.source()
      );
    },
  },
  computed: {
    diagramStatus() {
      return this.$store.state.project.diagramStatus;
    },
    updatePoints() {
      return [this.date, this.range, this.loops,this.node];
    },
    tabData() {
      if (this.allPoints.length > 0) {
        return this.allPoints;
      } else {
        return [];
      }
    },
  },
  mounted() {
    this.getPoints(
      this.loops,
      ["ALTERNATE", "SEPARATED"],
      Axios.CancelToken.source()
    );
  },
  methods: {
    async getPoints(loops, nodes, source) {
      this.currentCancelTokenSource = source;
      this.loading = true;
      this.allPoints = [];
      if (!loops) {
        return;
      }
      let promises = [];
      loops.forEach((item) => {
        let l = item;
        let temp = nodes.map((n) => {
          if (n == "ALTERNATE") {
            let obj = {
              buildingId: item.id,
              compareType: "ALTERNATE",
              date: dateFormat("YY-mm-dd", this.date) + "T00:00:00Z",
              dateRange: this.range.toUpperCase(),
              powerType: this.node.toUpperCase(),
            };
            return CompareClassifiedPower(obj, source);
          } else {
            let obj1 = {
              buildingId: item.id,
              compareType: "SEPARATED",
              date: dateFormat("YY-mm-dd", this.date) + "T00:00:00Z",
              dateRange: this.range.toUpperCase(),
              powerType: this.node.toUpperCase(),
            };
            return CompareClassifiedPower(obj1, source);
          }
        });

        this.savePoints(temp, nodes, l);
        promises = promises.concat(temp);
      });
      await Promise.all(promises);
      this.loading = false;
    },
    async savePoints(promises, nodes, l) {
      let res = await Promise.all(promises);
      let list = {
        name: "",
        id:"",
        period: "", //本期
        previous: "", //上期
        ringlv: "", //环比
        same: "", //同期
        ratiolv: "", //同比
      };
      nodes.forEach((n, j) => {
        let pointsArray = res[j].data.data.data[0];
        list.name = l.name;
        list.id = l.id
        if (n == "ALTERNATE") {
          list.period = pointsArray[1].toFixed(2);
          list.previous = pointsArray[0].toFixed(2);
          list.ringlv = pointsArray[0]
            ? (
                ((pointsArray[1] - pointsArray[0]) / pointsArray[0]) *
                100
              ).toFixed(2)
            : "0.00";
        } else {
          (list.same = pointsArray[0].toFixed(2)), //同期
            (list.ratiolv = pointsArray[0]
              ? (
                  ((pointsArray[1] - pointsArray[0]) / pointsArray[0]) *
                  100
                ).toFixed(2)
              : "0.00"); //同比
        }
      });
      this.allPoints.push(list);
      return res;
    },
    reShow() {
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
};
</script>

<style scoped lang="less">
.tip {
  width: 100%;
  height: 100%;
  font-size: 16rem;
  color: #8c939d;
}

.loading {
  width: 28rem;
  height: 28rem;
  animation: loading 1s linear infinite;
}

@keyframes loading {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
